var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#cart--jDdoB';
                    var viewUrl = 'sprites.svg#view-cart--jDdoB';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };